<template>
  <div class="w-full flex h-full justify-center p-1 z-50">
    <l-button       
      id="btnVerified"
      v-if="value == 'verified'"
      type="success"
      size="fill"
      @click="onUndoClick()">Undo verify</l-button>

    <l-button 
      id="btnPreVerified"
      v-else-if="value == 'pre_verified' || value == 'not_verified'"
      type="warning"
      size="fill"
      @click="onVerifyClick()">Verify</l-button>

    <label id="btnNotVerified" v-else class="text-red-600 font-bold">Cannot verify dataset</label>
  </div>
</template>

<script>
import Handsontable from "handsontable";
import { LButton } from "@/components/forms";
import VerifyService from "@/helpers/services/qualitycontrol/verify.service";
import Notify from "@/helpers/notify";

export default {
  name: "LLButtonRenderer",
  components: {
    LButton
  },
  data: function() {
    return {
      hotInstance: null,
      TD: null,
      row: null,
      col: null,
      prop: null,
      value: null,
      cellProperties: null
    };
  },
  methods: {
    async onVerifyClick(e) {
      const physicalIndex = this.hotInstance.toPhysicalRow(this.row);
      let row = this.hotInstance.getSourceDataAtRow(physicalIndex);

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while verifying data",
            async () => {
              const rowsAffected = await VerifyService.verify(
                row.month,
                row.year,
                row.id
              );

              const activeEditor = this.hotInstance.getActiveEditor();
              this.hotInstance.setDataAtRowProp([
                [this.row, "action", "verified"],
                [this.row, "verified", rowsAffected.verified],
                [this.row, "pre_verified", 0],
                [this.row, "not_verified", 0]
              ]);
              
              Notify.success("Data has been set to verified!");
            }
          );
        }
      }, "This will verify your data. <br/><br/>Do you want to continue?");
    },

    async onUndoClick(e) {
      const physicalIndex = this.hotInstance.toPhysicalRow(this.row);
      let row = this.hotInstance.getSourceDataAtRow(physicalIndex);

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while undoing verified data",
            async () => {
              const rowsAffected = await VerifyService.undo(
                row.month,
                row.year,
                row.id
              );

              const activeEditor = this.hotInstance.getActiveEditor();
              this.hotInstance.setDataAtRowProp([
                [this.row, "action", row.not_verified > 0 ? "not_verified" : "pre_verified"],
                [this.row, "verified", 0],
                [this.row, "pre_verified", rowsAffected.pre_verified]
              ]);
                            
              Notify.success("Data has been set to pre verified!");
            }
          );
        }
      }, "This will undo verified data. <br/><br/>Do you want to continue?");
    }
  }
};
</script>